<h1>Create a random user for testing</h1>
<form [formGroup]="userForm">

  <input type="text" placeholder="Email" formControlName="Email" size="100" />
  <br />

  <input type="text" placeholder="FirstName" formControlName="FirstName" size="100" />
  <br />

  <input type="text" placeholder="LastName" formControlName="LastName" size="100" />
  <br />

  <input type="text" placeholder="PhoneNumber" formControlName="PhoneNumber" />
  <br />

  <br />
  <button (click)="doit($event)">do it</button>
</form>
<hr />
{{userForm.value|json}}
<hr />

<div *ngIf="result" style="margin-top: 20px;">
  {{result|json}}
</div>
